import React, { useState, useLayoutEffect, useRef } from 'react';

const BackToTop = () => {
  const [showScroll, setShowScroll] = useState(false);
  const [lastScroll, setLastScroll] = useState(0);
  const ourRef = useRef(null);

  useLayoutEffect(() => {
    //const topPosition = ourRef.current.getBoundingClientRect().top;
    const onScroll = () => {
      const scrollPosition = window.scrollY - window.innerHeight;
      if (lastScroll < scrollPosition) {
        // trigger animation
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
      setLastScroll(scrollPosition);
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [lastScroll]);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
    <p ref={ourRef} className="scroll-to-top" onClick={scrollTop} style={{ bottom: showScroll ? '10px' : '-40px' }}>
      SCROLL TO TOP
    </p>
  );
};

export default BackToTop;

/*

useEffect(() => {
  window.addEventListener('scroll', checkScrollTop);
  return window.removeEventListener('scroll', checkScrollTop);
}, []);

*/
